module.exports = __webpack_public_path__ + "img/053-ghana.343e618a.svg";